/* eslint-disable react/no-danger-with-children */

import React from 'react';
import * as classes from './App.module.css';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const App = ({ image, name, desc, link, odd = true }) => {

  let imageAniamtion = "slide-right";
  let infoAniamtion = "slide-left";
  let containerClass = "";
  let wrapperClass = classes.odd;
  if (!odd) {
    imageAniamtion = "slide-left";
    infoAniamtion = "slide-right";
    containerClass = classes.reverse;
    wrapperClass = classes.even;
  }

  const imageObj = getImage(image);
  return <div className={wrapperClass} >
    <div className={`${classes.appContainer} ${containerClass}`}>
      <div className={classes.imageContainer} data-aos={imageAniamtion} >
        <GatsbyImage
          image={imageObj}
          alt="Application"
          placeholder="blurred"
        />
      </div>
      <div className={classes.infoContainer} data-aos={infoAniamtion}>
        <p className={classes.appName}>{name}</p>
        <div className={classes.appDesc} dangerouslySetInnerHTML={{ __html: desc }} />
        <div>
          <a target="_blank" rel="noreferrer" href={link}>
            <img alt='Get it on Google Play' style={{ width: '20rem' }} src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' />
          </a>
        </div>
      </div>
    </div>
  </div>;
}

export default App;